import { getGTMEventData } from '@tracking/components/transformer';
import { EVENT_NAMES } from '@tracking/components/constants';

function scrollFormatter(data) {
  const {
    verticalScroll, scrollPercentage, elementId, scrollDirection,
  } = data;
  return getGTMEventData(
    verticalScroll
      ? EVENT_NAMES.VERTICAL_SCROLL : EVENT_NAMES.HORIZONTAL_SCROLL,
    scrollDirection,
    { ...data, verticalScroll: undefined },
    elementId,
    scrollPercentage,
  );
}

export default scrollFormatter;
